import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../styles/HomePageStyles/testimonials.css";
import Aos from "aos";
import "aos/dist/aos.css";
import test1 from "../assets/Teams/tm1.jpg";
import test2 from "../assets/Teams/team2.jpg";
import test3 from "../assets/Teams/team3.jpg";

const Testimonials = ({ testimonialsList }) => {
  Aos.init({
    offset: 0,
    duration: 1000,
    once: true,
    easing: "ease-out-cubic",
    disable: "phone",
  });

  // console.log("testimonialsList", testimonialsList);

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    customPaging: function (i) {
      return (
        <div className="custom-dot">
          <span>
            <i className="bi bi-dot"></i>
          </span>
        </div>
      );
    },
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="testimonials-container-wrapper">
      <div className="testimonials-container">
        <div className="testimonials_heading">
          <h2 data-aos="zoom-out">Testimonials</h2>
        </div>

        <div className="testimonials_item_container">
          <Slider {...settings}>
            {/* Team Member 1 */}
            {testimonialsList?.map((item) => (
              <div className="testimonials_item" key={item.id}>
                <div className="testimonials_item_img">
                  <img
                    src={item.image || test1}
                    alt="Manuel Ponzio"
                    className="img-fluid"
                  />
                </div>
                <div className="testimonials_item_details testimonials1">
                  {item.comment && item.comment !== "-" ? (
                    <p>{item.comment}</p>
                  ) : (
                    <p>
                      At Rollz Ice Cream, we turn every scoop into an
                      experience. Our signature rolled ice cream is made fresh
                      before your eyes, creating a visually stunning treat. With
                      endless flavor and topping combinations, each roll is
                      crafted just the way you love it. Come see the art of ice
                      cream come to life!
                    </p>
                  )}
                  <h3>{item.name}</h3>
                </div>
              </div>
            ))}

            {/* <div className="testimonials_item">
              <div className="testimonials_item_img">
                <img src={test1} alt="Manuel Ponzio" className="img-fluid" />
              </div>

              <div className="testimonials_item_details testimonials1">
                <h3>Scoop, Roll, and Enjoy the Sweetness!</h3>
                <p>
                  At Rollz Ice Cream, we turn every scoop into an experience.
                  Our signature rolled ice cream is made fresh before your eyes,
                  creating a visually stunning treat. With endless flavor and
                  topping combinations, each roll is crafted just the way you
                  love it. Come see the art of ice cream come to life!
                </p>
              </div>
            </div> */}
            {/* Team Member 2 */}
            {/* <div className="testimonials_item">
              <div className="testimonials_item_img">
                <img src={test2} alt="Manuel Ponzio" className="img-fluid" />
              </div>

              <div className="testimonials_item_details testimonials1">
                <h3>Your Ice Cream, Your Way – Rolled to Perfection!</h3>
                <p>
                  Experience the magic of ice cream like never before at Rollz
                  Ice Cream. Our signature rolled treats are fully customizable
                  with endless flavor and topping options, ensuring your perfect
                  dessert every time. Treat yourself to the joy of ice cream
                  rolled to perfection!
                </p>
              </div>
            </div> */}
            {/* Team Member 3 */}
            {/* <div className="testimonials_item">
              <div className="testimonials_item_img">
                <img src={test3} alt="Manuel Ponzio" className="img-fluid" />
              </div>

              <div className="testimonials_item_details testimonials1">
                <h3>Where Every Roll is a Masterpiece!</h3>
                <p>
                  Rollz Ice Cream is where creativity meets indulgence. Our ice
                  cream rolls are crafted with care, turning every scoop into an
                  art form. Whether you’re here for a quick treat or a special
                  celebration, each roll is a masterpiece that’s made to
                  delight!
                </p>
              </div>
            </div> */}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
